import {noop} from '@benchling/js-utils';
import React from 'react';

import {Model as SequencePrimer} from 'biojs/SequencePrimer';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface ExistingPrimersProps {
  isAssemblyPrimer: boolean;
  primers: Array<SequencePrimer>;
  single: boolean;
  used: boolean;
  onSelectPrimer?: (primer: SequencePrimer) => void;
}

export class ExistingPrimers extends React.Component<ExistingPrimersProps> {
  private renderHeading(): JSX.Element {
    const {isAssemblyPrimer, primers, used} = this.props;
    if (used) {
      if (isAssemblyPrimer) {
        return (
          <p>
            <p>Use the inputs below to adjust this assembly primer:</p>
          </p>
        );
      } else if (primers.length === 1 && primers[0].has('id')) {
        return (
          <p>
            <b>Editing this saved primer and its binding site:</b>
          </p>
        );
      } else {
        return (
          <p>
            <b>Editing this saved primer and adding a binding site:</b>
          </p>
        );
      }
    } else if (primers.length > 1) {
      return <p>Saved primers exist with the same bases:</p>;
    } else {
      return <p>Saved primer exists with the same bases:</p>;
    }
  }

  private renderExistingPrimer(
    primer: SequencePrimer,
    onSelectPrimer: (primer: SequencePrimer) => void
  ): JSX.Element {
    const {single, used} = this.props;
    const folderName = primer.folder().name;
    const folderURL = primer.folder().url;
    return (
      <li key={primer.get('primer_id')} className="list-group-item clearfix existing-primer">
        {primer.name()}{' '}
        {(single || used) && folderName && folderURL && (
          // folderURL is an internal url, so target="_blank" is not problematic.
          <a href={folderURL} target="_blank" className="faded" rel="noreferrer">
            ({primer.get('owner')} / {folderName})
          </a>
        )}
        <span>
          {!used && (
            <button
              type="button"
              data-primer-id={primer.get('primer_id')}
              className="button button--primary button--mini js-existing-primer-use pull-right"
              onClick={() => {
                onSelectPrimer(primer);
              }}
            >
              Use
            </button>
          )}
        </span>
      </li>
    );
  }

  render(): JSX.Element {
    const {isAssemblyPrimer, primers, used, onSelectPrimer = noop} = this.props;
    return (
      <div className="row">
        <div className="col col-md-11 existing-primers">
          {this.renderHeading()}
          <ul className="list-group list-group-sm">
            {primers.map((primer) => this.renderExistingPrimer(primer, onSelectPrimer))}
          </ul>
          {used && !isAssemblyPrimer && (
            <p>
              You can also{' '}
              {primers.length === 1 && primers[0].has('id') ? (
                <a className="js-existing-primer-duplicate">duplicate it</a>
              ) : (
                <a className="js-existing-primer-remove">remove it</a>
              )}
              .
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default makeDeprecatedJadeStyleTemplate<ExistingPrimersProps>(ExistingPrimers);
